import { ASSET_PATHS } from "./asset-paths";

export const ICONS = {
	dashboard: "dashboard",
	lawsuits: "lawsuits",
	requests: "requests",
	beneficiaries: "beneficiaries",
	statistics: "statistics",
	departmentsRoles: "departments-roles-icon",
	addPlusCircle: "add-plus-circle-icon",
	addPlusCircleWhite: "add-plus-circle-white",
	backArrow: "back-arrow-icon",
	notices: "notices-icon",
	tabDetails: "tab-details",
	tabMemos: "tab-memos",
	tabMemosAttachments: "tab-memos-attachments",
	tabSessions: "tab-sessions",
	tabDecisions: "tab-decisions",
	tabComplaintStudy: "tab-complaint-study",
	tabLegalStudy: "tab-legal-study",
	recommendationReferral: "recommendation-referral",
	faq: "faq-icon",
	contactUs: "contact-us-icon",
	addCreate: "add-create-icon",
	addCreatePrimary: "add-create-icon-primary",
	addUser: "add-user-icon",
	check: "check-icon",
	checkWizard: "check-wizard",
	close: "close-icon",
	closeStroke: "close-stroke-icon",
	checkCircle: "check-circle-icon",
	addCircle: "add-circle-icon",
	paginationArrowRight: "pagination-arrow-right",
	paginationArrowRightDouble: "pagination-arrow-right-double",
	paginationArrowLeft: "pagination-arrow-left",
	paginationArrowLeftDouble: "pagination-arrow-left-double",
	professionalMonitoring: "professional-monitoring-icon",
	notifications: "notification-01",
	accountInfo: "account-info-icon",
	changeAccounts: "change-accounts-icon",
	logout: "logout-icon",
	userCircle: "user-circle-icon",
	search: "search-icon",
	searchStroke: "search-stroke",
	arrowLeftLong: "arrow-left-long",
	arrowRightLong: "arrow-right-long",
	chevronDownSm: "chevron-down-sm",
	chevronDown: "arrow-down-01",
	chevronRight: "arrow-right-02",
	sort: "sort-icon",
	scrollToTop: "scroll-to-top-icon",
	menuDotsVertical: "menu-dots-vertical",
	plus: "plus",
	plusWhite: "plus-icon-white",
	complaintsDocument: "complaints-document-icon",
	navDashboard: "nav-dashboard",
	navComplaints: "nav-complaints",
	navNotices: "nav-notices",
	navProfessionalMonitoring: "nav-professional-monitoring",
	navLawyerInquiry: "nav-lawyer-inquiry",
	navFaq: "nav-faq",
	navContactUs: "nav-contact-us",
	requestDataDocument: "request-data-document",
	classificationTag: "classification-tag",
	classificationMonitoring: "classification-monitoring",
	classificationRecords: "classification-records",
	socialX: "social-1",
	socialLinkedin: "social-2",
	socialYoutube: "social-youtube",
	chevronRightSm: "chevron-right-sm",
	activityIcon: "activity",
	transitionIcon: "transition",
	userRoleIcon: "user-role",
	questionMarkIcon: "question_mark",
	lock: "lock-icon",
	viewReport: "view-report",
	editStudy: "edit-study",
	lawsuitPartyMessage: "lawsuit-party-message",
	infoCircle: "info-circle",
	statusCardInfoGray: "status-card-info-gray",
	statusCardInfoBlue: "status-card-info-blue",
	statusCardDanger: "status-card-danger",
	statusCardWarning: "status-card-warning",
	statusCardSuccess: "status-card-success",
	chatbot: "chatbot",
	reports: "reports",
	reportsAlbalaghat: "reports-albalaghat",
	referral: "referral",
	account: "account",
	holidaysManagement: "calendar-lines",
	history: "history",
	auditLogTransactions: "audit-log-transactions",
	auditLogGeneral: "audit-log-general",
	feedback: "feedback",
	sessionCalendar: "session-calendar",
	sessionClock: "session-clock",
	sessionReschedule: "session-reschedule",
	sessionCancel: "session-cancel",
	sessionLink: "session-link",
	sessionUpload: "session-upload",
	sessionWarning: "session-warning",
	sessionPlay: "session-play",
	sessionJoin: "session-join",
	sessionEdit: "session-edit",
	sessionEye: "session-eye",
	sessionCheck: "session-check",
	sessionQuestion: "session-question",
	sessionDocument: "session-document",
	sessionLock: "session-lock",
	sessionInfo: "session-info",
	sessionClose: "session-close",
	sessionPlus: "session-plus",
	sessionTrash: "session-trash",
} as const;

export type IconName = (typeof ICONS)[keyof typeof ICONS];

export const ASSETS = { icons: ICONS, paths: ASSET_PATHS };

export const PAGE_ICON_MAP: Record<string, IconName> = {
	dashboard: ICONS.dashboard,
	faq: ICONS.faq,
	help: ICONS.faq,
	contact: ICONS.contactUs,
	"contact-us": ICONS.contactUs,
	roles: ICONS.departmentsRoles,
	"users/roles": ICONS.departmentsRoles,
	notices: ICONS.notices,
	notes: ICONS.notices,
	reports: ICONS.reports,
	"reports-complaints": ICONS.complaintsDocument,
	"reports-notices": ICONS.reportsAlbalaghat,
	"reports-professional-monitoring": ICONS.professionalMonitoring,
	"reports-users": ICONS.beneficiaries,
	"reports-beneficiaries": ICONS.beneficiaries,
	notifications: ICONS.notifications,
	requests: ICONS.requests,
	lawsuits: ICONS.lawsuits,
	"professional-monitoring": ICONS.professionalMonitoring,
	users: ICONS.beneficiaries,
	beneficiaries: ICONS.beneficiaries,
	statistics: ICONS.statistics,
	"transaction-lifespan": ICONS.statistics,
	"transaction-lifespan-summary": ICONS.statistics,
	complaints: ICONS.complaintsDocument,
	complaint: ICONS.complaintsDocument,
	referral: ICONS.referral,
	account: ICONS.account,
	bell: ICONS.notifications,
	"holidays-management": ICONS.holidaysManagement,
	"audit-log": ICONS.history,
	"audit-log-transactions": ICONS.auditLogTransactions,
	"audit-log-general": ICONS.auditLogGeneral,
	"audit-log/transactions": ICONS.auditLogTransactions,
	"audit-log/general": ICONS.auditLogGeneral,
	feedback: ICONS.feedback,
};

export const PAGE_ICON_ASSET_MAP = PAGE_ICON_MAP;
